import {LogbogSvarmulighedResponseModel} from "../../../services/api/logbogEvaluering/logbogSvarmulighedResponseModel";

export class SvarmulighedModel {

    public static FromResponseModel(svarmulighedResponseModel: LogbogSvarmulighedResponseModel): SvarmulighedModel{
        let newModel = new SvarmulighedModel();

        newModel.id = svarmulighedResponseModel.id;
        newModel.tekst = svarmulighedResponseModel.tekst;
        newModel.sortOrder = svarmulighedResponseModel.sortOrder;
        newModel.svarVaerdi = svarmulighedResponseModel.svarVaerdi;
        newModel.farvekode = svarmulighedResponseModel.farvekode;
        newModel.udeladSvarvaerdi = svarmulighedResponseModel.udeladSvarVaerdi;

        return newModel;
    }

    id: string;
    tekst: string;
    sortOrder: number;
    svarVaerdi?: number;
    farvekode?: string;
    udeladSvarvaerdi?: boolean;
}
